import React, { useState } from "react";
import { Button, Checkbox, Col, Row } from "@mtm/components";
import { Input } from "antd";
import "antd/dist/antd.css";
import { isEmpty, formatPhoneNumber } from "../../helpers/ValidationHelpers";
import { ReCaptcha } from "../ReCaptcha/ReCaptcha";
import NiceToMeetYou from "../../assets/images/NiceToMeetYou.png";
import {
  InsertParameter,
  RegistrationComponentLoad,
  RegistrationEnums,
  TrackAnalytics,
} from "../../types/ApplicationTypes";
import {
  GetPersonRegistrationMatch,
  UserRegistration,
} from "../../services/RegistrationService";
import Styles from "./IDPNotExists.module.scss";
import commonStyles from "../Email/Email.module.scss";
import { notification } from "antd";
import { backArrowIcon } from "../../assets/images";

type Props = {
  setPageType: Function;
  emailId: string;
  setPersonData: Function;
  wandaOrgId: number;
};

const FieldNames = {
  firstName: "firstName",
  lastName: "lastName",
  phoneNumber: "phoneNumber",
  emailAddress: "emailAddress",
  promotionalCheck: "promotionalCheck",
};

type DynamicObject = {
  [key: string]: any;
};

const IDPNotExists: React.FC<Props> = ({
  setPageType,
  emailId,
  setPersonData,
  wandaOrgId,
}) => {
  const [myInfo, setMyInfo] = useState<DynamicObject>(initializeFieldValue());
  const [check, setCheck] = useState<boolean>(true); //Promotional checkbox
  const { firstName, lastName, phoneNumber } = myInfo;
  const [btnClicked, setBtnClicked] = useState<boolean>(false);

  function initializeFieldValue() {
    return {
      [FieldNames.firstName]: "",
      [FieldNames.lastName]: "",
      [FieldNames.phoneNumber]: "",
      [FieldNames.emailAddress]: emailId,
      [FieldNames.promotionalCheck]: true,
    };
  }
  function isFieldsValid() {
    return Object.keys(myInfo).every((key) => !isEmpty(myInfo[key]));
  }
  function handleMyInfoValueChange(fieldName: string, value: any) {
    if (fieldName === FieldNames.phoneNumber) {
      const output = formatPhoneNumber(value);
      setMyInfo((myInfo) => ({ ...myInfo, [fieldName]: output }));
    } else {
      setMyInfo((myInfo) => ({
        ...myInfo,
        [fieldName]: value,
      }));
    }
    setMyInfo((myInfo) => ({ ...myInfo, [FieldNames.emailAddress]: emailId }));
  }

  function handleMyInfoCheckChange(value: any) {
    setCheck(value);
    setMyInfo((myInfo) => ({
      ...myInfo,
      [FieldNames.promotionalCheck]: !check,
    }));
  }

  async function handleIDPPersonMatchCheck(execute: () => Promise<string>) {
    setBtnClicked(true);
    TrackAnalytics(
      "/Registration",
      "IDP Doesn’t Exist - Continue Button Clicked",
      "IDP Doesn’t Exist"
    );

    const recaptchaToken = await execute();
    setPersonData(myInfo);
    const data = {
      firstName: myInfo.firstName,
      lastName: myInfo.lastName,
      phoneNumber: myInfo.phoneNumber,
      email: myInfo.emailAddress,
      promotionalCheck: myInfo.promotionalCheck,
      searchpattern: RegistrationEnums.IDPDoesnotExists,
      recaptchaToken: recaptchaToken,
    };

    var result = await GetPersonRegistrationMatch(data); //Check for person match

    if (result.success === true) {
      setPageType(RegistrationComponentLoad.PersonMatch);
    } else {
      const token = await execute();
      const data = {
        firstName: myInfo.firstName,
        lastName: myInfo.lastName,
        recaptchaToken: token,
        dateOfBirth: RegistrationEnums.DateOfBirth,
        zipcode: null,
        clientId: RegistrationEnums.clientId,
        sourceSystemID: RegistrationEnums.SourceSystemID,
        createRelation: true,
        organizationId: wandaOrgId,
        keyTypeId: RegistrationEnums.KeyTypeId,
        isActive: true,
        personTypeId: RegistrationEnums.PersonTypeId,
        gender: "N/A",
        detailsExist: false,
        personFound: false,
        roles: [
          {
            roleName: RegistrationEnums.Role,
          },
        ],
        personAttributes: {
          personContact: {
            WandaEmail: myInfo.emailAddress,
            WandaEmailAddressAttribute: {
              notificationOn: true,
              communicationTypes: {
                informative: true,
                promotional: myInfo.promotionalCheck,
              },
            },
            primaryPhone: myInfo.phoneNumber,
            PrimaryPhoneAttribute: {
              canReceiveTexts: true,
              notificationOn: true,
              communicationTypes: {
                informative: true,
              },
            },
            primaryEmailAddress: myInfo.emailAddress,
            primaryEmailAddressAttribute:{
              notificationOn: true,
              communicationTypes: {
                informative: true,
                promotional: myInfo.promotionalCheck,
              },
            }
          },
          personInfo: {
            primaryLanguage: "English",
          },
          homeAddress: {
            address1: "123 Any Street",
            address2: "",
            city: "Columbus",
            state: "OH",
            zip: "43068",
            county: "",
          },
          mailingAddress: {
            address1: "123 Any Street",
            address2: "",
            city: "Columbus",
            state: "OH",
            zip: "43068",
            county: "",
          },
        },
      };

      try {
        const result = await UserRegistration(data);
        if (result.passwordLink === true) {
          setPageType(RegistrationComponentLoad.Message);

          !myInfo.promotionalCheck &&
            TrackAnalytics(
              "/Registration",
              "Promo Email opt out",
              "IDP Doesn’t Exist Page"
            );
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description:
            "Password link generation failed. Please try again later.",
        });
      }
    }
  }

  const handleBack = () => setPageType(RegistrationComponentLoad.Email);

  return (
    <>
      <div className="container">
        <Row gutter={[0, 21]}>
          <Col xs={2} lg={3} />
          <Col>
            <Button
              link={true}
              clickHandler={handleBack}
              className={commonStyles.backBtn}
            >
              <div>
                <img src={backArrowIcon} alt="navigate-back" />
                Back
              </div>
            </Button>
          </Col>
          <Col xs={0} lg={24} />
        </Row>
        <Row className={Styles.IDPNotExists}>
          <Col span={2} />
          <Col span={24} lg={10}>
            <img
              src={NiceToMeetYou}
              alt="NiceToMeetYou"
              className={Styles.imageWidthIDP}
            />
          </Col>
          <Col span={2} />
          <Col span={24} lg={10} className={Styles.iDPDiv}>
            <div>
              <div className={Styles.IDPHeadingText}>
                Tell us more about yourself
              </div>
              <div className={"subTextFont " + Styles.IDPNotExistsInputPadding}>
                <Input
                  type="Text"
                  placeholder="First Name"
                  onChange={(e) => {
                    handleMyInfoValueChange(
                      FieldNames.firstName,
                      e.target.value
                    );
                  }}
                  value={firstName}
                  className="mtm-input-alternate"
                />
              </div>
              <div className={"subTextFont " + Styles.IDPNotExistsInputPadding}>
                <Input
                  type="Text"
                  placeholder="Last Name"
                  onChange={(e) => {
                    handleMyInfoValueChange(
                      FieldNames.lastName,
                      e.target.value
                    );
                  }}
                  value={lastName}
                  className="mtm-input-alternate"
                />
              </div>
              <div className={"subTextFont " + Styles.IDPNotExistsInputPadding}>
                <Input
                  type="Text"
                  placeholder="Phone Number"
                  onChange={(e) => {
                    handleMyInfoValueChange(
                      FieldNames.phoneNumber,
                      e.target.value
                    );
                  }}
                  value={phoneNumber}
                  className="mtm-input-alternate"
                />
              </div>
              <div className={Styles.checkboxIDPDiv}>
                <div className={Styles.checkboxIDP}>
                  <Checkbox
                    checked={check}
                    onChange={(e) => {
                      handleMyInfoCheckChange(e.target.checked);
                    }}
                  ></Checkbox>
                </div>
                <div className={"subTextFont " + Styles.emailIndication}>
                  Receive emails from us and stay up to date with Wanda’s new
                  services and features.
                </div>
              </div>
              <Col span={24} lg={20}>
                <ReCaptcha>
                  {(captcha) => (
                    <Button
                      clickHandler={(e) =>
                        handleIDPPersonMatchCheck(captcha.execute)
                      }
                      disabled={
                        !isFieldsValid() ||
                        btnClicked ||
                        myInfo.phoneNumber.length !== 14 ||
                        !captcha.isReady
                      }
                      className={
                        !isFieldsValid() ||
                        myInfo.phoneNumber.length !== 14 ||
                        !captcha.isReady
                          ? "wandaBtnDisabled"
                          : "wandaBtnEnabled"
                      }
                    >
                      Continue
                    </Button>
                  )}
                </ReCaptcha>
              </Col>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default IDPNotExists;
